import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from "rxjs";
import {DISPATCHER_PREFIX} from "../../../../../mx-core/src/lib/consts/data-service-consts";

@Injectable({
    providedIn: 'root'
})
export class PrlZoneDataService {

    constructor(private httpClient: HttpClient) {
    }

    getThumbnailUrl(id: number): string {
        return DISPATCHER_PREFIX + `/creatives/${id}/thumbnail`;
    }

    getThumbnail(id: number): Observable<HttpResponse<Blob>> {
        return this.httpClient.get(this.getThumbnailUrl(id), {responseType: 'blob', observe: 'response'});
    }
    getPromoPreview(id: number): Observable<HttpResponse<Blob>> {
        return this.httpClient.get(DISPATCHER_PREFIX + `/creatives/${id}`, {responseType: 'blob', observe: 'response'});
    }
}
